import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'ngx-form-stepper',
  templateUrl: './form-stepper.component.html',
  styleUrls: ['./form-stepper.component.scss'],
})
export class FormStepperComponent implements OnInit {
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  fifthFormGroup: FormGroup;
  public selectedStepperIndex: number = 1;
  user: any;
  calendarId: number;
  @Input() manageSchoolYear: boolean; // To identify if we are on manage school year page from instructional period page

  constructor(
    private _formBuilder: FormBuilder,
    private router: Router,
    public storageservice: StorageService,
    public route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    this.user = this.storageservice.getItem('user');
    this.calendarId = Number(this.route.snapshot.paramMap.get('calendarId'));
    await this.setStepperValuePerRouteUrl();
  }

  navigateData(event: any) {
    const isTeacherOnly = this.storageservice.checkUserRole(this.user.user.role_id, 'teacher_only');

    if (isTeacherOnly) {
      if (event.target.innerText.toLowerCase().includes('academic information')) {
        this.selectedStepperIndex = 0;
      } else if (event.target.innerText.toLowerCase().includes('calendar setup')) {
        this.selectedStepperIndex = 1;
      }
    } else {
      if (event.target.innerText.toLowerCase().includes('personal information')) {
        this.selectedStepperIndex = 0;
      } else if (event.target.innerText.toLowerCase().includes('academic information')) {
        this.selectedStepperIndex = 1;
      } else if (event.target.innerText.toLowerCase().includes('bell schedule')) {
        this.selectedStepperIndex = 2;
      } else if (event.target.innerText.toLowerCase().includes('school instructions periods')) {
        this.selectedStepperIndex = 0;
      } else if (event.target.innerText.toLowerCase().includes('school calender')) {
        this.selectedStepperIndex = 1;
      }
    }
  }

  setStepperValuePerRouteUrl() {
    try {
      const isTeacherOnly = this.storageservice.checkUserRole(this.user.user.role_id, 'teacher_only');

      if (isTeacherOnly) {
        if (this.router.url.toLowerCase().includes('/administration/teacher-academic-portal')) {
          this.selectedStepperIndex = 0;
        } else if (this.router.url.toLowerCase().includes('/administration/calendar_setup')) {
          this.selectedStepperIndex = 1;
        }
      } else {
        if (this.router.url.toLowerCase().includes('administration/teacher-profile')) {
          this.selectedStepperIndex = 0;
        } else if (this.router.url.toLowerCase().includes('/administration/teacher-academic-portal')) {
          this.selectedStepperIndex = 1;
        } else if (this.router.url.toLowerCase().includes('/administration/teacher-periods')) {
          this.selectedStepperIndex = 2;
        } else if (this.router.url.toLowerCase().includes('/administration/calendar_setup')) {
          this.selectedStepperIndex = 2;
        } else if (this.router.url.toLowerCase().includes('/administration/school-instructional-peroids')) {
          if (this.router.url.toLowerCase().includes('/administration/school-instructional-peroids/teacher')) {
            this.selectedStepperIndex = 1;
          } else {
            this.selectedStepperIndex = 0;
          }
        } else if (this.router.url.toLowerCase().includes('/calendar/administration')) {
          this.selectedStepperIndex = 1;
        } else if (this.manageSchoolYear) {
          this.selectedStepperIndex = 0;
        } else if (this.calendarId) {
          // When calendarId is present in the route params, we are on school calendar page

          if (this.router.url.toLowerCase().includes('/manage-school-years')) {
            this.selectedStepperIndex = 1;
          }
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }
}
